'use client';

import tinycolor from "../../../external/tinycolor2/esm/tinycolor.js";
const hasContrast = (a, b) => tinycolor.isReadable(a, b, { level: "AA", size: "small" });
export {
  hasContrast
};
